module.exports = __webpack_public_path__ + "static/media/DemuthLetter.76a99dbe.wav";